import { parse } from 'node-html-parser';

export function modifyUrlLoadedComponent(response: string): string {
  const rootElement = parse(response);

  // Modify the links within the article tiles to open in a new tab
  const anchorTags = rootElement.querySelectorAll(
    'beacon-article-tile a, fai-beacon-article-tile a',
  );
  anchorTags.forEach((anchor) => {
    anchor.setAttribute('target', '_blank');
  });
  const beaconButtons = rootElement.querySelectorAll(
    'fai-beacon-button, beacon-button',
  );
  beaconButtons.forEach((beaconButton) => {
    beaconButton.setAttribute('link-target', '_blank');
  });

  const modifiedResponse = rootElement.innerHTML;

  return modifiedResponse.replaceAll('fai-beacon', 'beacon');
}
